export function jsonToFormData<T extends object>(json: T) {
  const formData = new FormData();
  Object.keys(json).forEach((key) => {
    const value = json[key as keyof T];
    if (typeof value === "number") {
      formData.append(key, value.toString());
    } else if (typeof value === "string") {
      formData.append(key, value);
    } else if (value instanceof Date) {
      formData.append(key, value.toISOString());
    } else if (typeof value === "object" && value !== null) {
      formData.append(key, JSON.stringify(value));
    } else {
      throw new Error(`Unexpected type for value ${key}`);
    }
  });
  return formData;
}

export function isJsonString(str: string) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const documentFormat = (text: string) => {
  return text.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};

export const REMOVE_CURLY_BRACKETS = /\{\{|\}\}/gi;

export const formatToCpf = (value: string) => {
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
};

export const hexToRgbA = (hex: string, opacity: number) => {
  let c: string;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("").join("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]].join("");
    }
    c = "0x" + c;
    return (
      "rgba(" +
      [
        (parseInt(c) >> 16) & 255,
        (parseInt(c) >> 8) & 255,
        parseInt(c) & 255,
      ].join(",") +
      `,${opacity})`
    );
  }
  throw new Error("Bad Hex");
};

export const fileToRawBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      const base64 = reader.result?.toString().split(",")[1];

      if (base64) {
        resolve(base64);
      } else {
        reject(new Error("Error converting file to Base64"));
      }
    };

    reader.onerror = (error) => reject(error);
  });
};

export const rawBase64ToFile = async (
  rawBase64String: string,
  fileName: string,
  mimeType: string,
) => {
  const dataUrl = `data:${mimeType};base64,${rawBase64String}`;
  const response = await fetch(dataUrl);
  const blob = await response.blob();

  return new File([blob], fileName, { type: mimeType });
};

export const dateOnlyStringToNewDate = (dateString: string) => {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};
